module.exports = __webpack_public_path__ + "img/builder-37.54371963.webp";